module.exports = __webpack_public_path__ + "img/left-arrow.68d78134.svg";